import React, { useRef } from "react";
import { useNewton } from "./store/NewtonContext";
import { MiniSwingLibraryProvider } from "./store/miniSwingLibraryStore";
import VideoMetadata from "./components/VideoMetadata";
import { Header } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";
import { Body } from "./components/Body/Body";
import { SessionMenu } from "./components/SessionMenu/SessionMenu";
import { TbAtom } from "react-icons/tb";
import Popover from "../../../../components/shared/Popover/Popover";
import { useMediaQuery } from "react-responsive";

export default function Newton() {
  const { isMetadataOpen, isNewtonOpen, setIsNewtonOpen } = useNewton();

  const textareaRef = useRef(null);

  const handleOpen = () => {
    setIsNewtonOpen((prev) => !prev);
  };

  const handleClose = () => {
    setIsNewtonOpen(false);
  };

  const isSm = useMediaQuery({ query: "(min-width: 640px)" });

  // Match previous behavior: full height on small screens, capped on wider viewports
  const targetHeight = isSm ? "calc(100vh - 8rem)" : "100%";

  return (
    <MiniSwingLibraryProvider>
      <Popover
        align="end"
        containerClassName="fixed bottom-12 right-10 z-[10]"
        contentClassName="" // panel styles go on the inner div below
        hideTriggerWhenOpen={true}
        isOpen={isNewtonOpen}
        offset={0}
        onClose={handleClose}
        side="top"
        trigger={
          <button
            className="bg-grayTrue800 hover:bg-grayTrue700 flex items-center gap-2 rounded-full px-4 py-2.5 text-white shadow-lg transition-colors"
            onClick={handleOpen}
            type="button"
          >
            Ask SAMI (Beta) <TbAtom className="size-5" />
          </button>
        }
      >
        <div
          className="border-gray800 bg-grayTrue900 flex flex-col overflow-hidden rounded-xl border transition-[height] duration-300 ease-in-out"
          style={{
          maxHeight: targetHeight,
          maxWidth: isSm ? "75vw" : "100vw",
          minHeight: targetHeight,
          minWidth: isSm ? "75vw" : "100vw",
          }}
        >
          {isMetadataOpen ? (
            <VideoMetadata />
          ) : (
            <>
              <Header handleClose={handleClose} />

              {/* Body + sessions menu */}
              <div className="flex flex-1 min-h-0 min-w-0">
                <SessionMenu />
                <div className="flex flex-1 min-h-0 min-w-0 overflow-x-hidden">
                  <div className="scrollbar-hide flex flex-1 min-h-0 min-w-0 flex-col-reverse overflow-y-auto overflow-x-hidden px-4 py-6">
                    <Body textareaRef={textareaRef} />
                  </div>
                </div>
              </div>

              {/* Footer – pinned by flexbox (no sticky) */}
              <div className="bg-grayTrue900 px-4 pb-4">
                <Footer textareaRef={textareaRef} />
              </div>
            </>
          )}
        </div>
      </Popover>
    </MiniSwingLibraryProvider>
  );
}
